import { Box, Typography } from '@mui/material';
import { Link, useLocation } from '@tanstack/react-router';
import React from 'react';

import { RailNavItem } from '@/layouts/layout.types';

interface IProps {
  item: RailNavItem;
}

const SocialFeedRailNavItem = ({ item }: IProps) => {
  const { pathname } = useLocation();

  const isActive = (path: string) => pathname.toLowerCase().startsWith(path);

  const IconComponent = item.icon;

  return (
    <Link key={item.path} to={item.path} className='w-full'>
      <Box
        data-tour={item.dataTour}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 0.5,
          py: 1,
          cursor: 'pointer',
          color: isActive(item.path) ? '#CC4E00' : '#000000',
          width: '100%',
          '&:hover': {
            bgcolor: '#CC4E0022'
          }
        }}
      >
        <IconComponent className='h-[28px] w-[28px]' />
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 500,
            textAlign: 'center',
            color: isActive(item.path) ? '#CC4E00' : '#000000',
            fontFamily: 'Inter'
          }}
        >
          {item.label}
        </Typography>
      </Box>
    </Link>
  );
};

export default SocialFeedRailNavItem;
